export default {"src":"/_next/static/media/star-solid.f9203db2.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};